import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/** Shared empty / no-data state for dashboard widgets (manager-friendly copy). */
export default function EmptyWidgetState({
  title = "No data for this range",
  hint = "Try a wider date range or verify the OpenSearch index has matching documents.",
}: {
  title?: string;
  hint?: string;
}) {
  return (
    <Box
      sx={{
        height: "100%",
        minHeight: 120,
        display: "grid",
        placeItems: "center",
        textAlign: "center",
        px: 2,
        color: "text.secondary",
      }}
    >
      <Box>
        <Typography variant="subtitle1" fontWeight={600} color="text.primary">
          {title}
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {hint}
        </Typography>
      </Box>
    </Box>
  );
}
